import React, { useState } from "react"
import { XMarkIcon } from "@heroicons/react/24/outline"

import Modal from "../../../components/modal"
import { useNana } from "../../../hooks/useNana"
import * as Commands from "../../../../model/commands"
import { Idea, WebSource } from "../../../../model/types"
import GoalAutocomplete from "../../../components/goal_autocomplete"
import IdeaBox from "../../../components/idea_box"
import { AutocompleteResult } from "../../../components/autocomplete"
import Input from "../../../components/input"

export default function EditSourceForm({
  source,
  close,
}: {
  source: WebSource
  close: () => void
}) {
  const { model, commander } = useNana()

  const [name, setName] = useState<string>(source?.name || "")
  const [selectedGoal, setSelectedGoal] = useState<Idea | null>(
    source.goalId ? model.getIdea(source.goalId) : null
  )

  const submit = () => {
    const updatedFields = {}
    if (name != source.name)
      updatedFields["userProvidedName"] = name == "" ? null : name
    if (selectedGoal?.id != source.goalId)
      updatedFields["goalId"] = selectedGoal?.id || null

    close()
    if (Object.keys(updatedFields).length == 0) return

    commander.exec(
      new Commands.SetWebSourceFieldsCommand({
        id: source.id,
        fields: updatedFields,
      })
    )
  }

  return (
    <>
      <Modal
        open={true}
        primaryButton={{
          text: "Edit source",
          action: () => submit(),
          disabled: false,
        }}
        secondaryButton={{
          text: "Cancel",
          action: () => close(),
          disabled: false,
        }}
        leftButton={{
          text: "",
          action: null,
          disabled: true,
        }}
        close={() => close()}
      >
        <Input
          label="Name"
          name="name"
          type="text"
          placeholder={source.scannedName || source.url || "Uploaded PDF"}
          error={null}
          disabled={false}
          value={name}
          onChange={(newName) => setName(newName)}
          testid="new-source-url-input"
          autoComplete="off"
        />

        <label className="block mt-4 mb-2 text-sm font-medium leading-6 text-gray-900 dark:text-gray-50">
          Associated goal (optional)
        </label>
        {selectedGoal ? (
          <div className="flex justify-between items-center text-sm text-gray-700 dark:text-gray-100">
            <div className="flex justify-start items-center gap-3">
              <IdeaBox idea={selectedGoal} />
              <div>{selectedGoal.title}</div>
            </div>
            <div
              onClick={() => setSelectedGoal(null)}
              className="cursor-pointer"
            >
              <XMarkIcon className="h-5 w-5 text-gray-500 hover:text-gray-300" />
            </div>
          </div>
        ) : (
          <GoalAutocomplete
            select={(result: AutocompleteResult<Idea>, _filter) => {
              if (result.type == "none") return false
              const goal = result.item
              setSelectedGoal(goal)
              return true
            }}
            onEscape={() => close()}
            inputStyle="form"
          />
        )}
      </Modal>
    </>
  )
}
